import {
  authorizedGetCall,
  authorizedPostCall,
  authorizedPutCall,
  authorizedDeleteCall,
} from "./APIsService";

export const getSubCategories = (id) => {
  return new Promise((resolve, reject) => {
    authorizedGetCall(`sub-categories/${id}`)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const addSubCategory = (data) => {
  return new Promise((resolve, reject) => {
    authorizedPostCall(`categories`, data)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updateSubCategory = (id, data) => {
  return new Promise((resolve, reject) => {
    authorizedPutCall(`categories/${id}`, data)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteSubCategory = (id) => {
  return new Promise((resolve, reject) => {
    authorizedDeleteCall(`categories/${id}`)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
